import { useState } from "react";
// import { useNavigate } from "react-router-dom";
import { Pathname } from "../../../constants/pathnames/pathname";
import { Box, Grid, styled } from "@mui/material";
// import { styled } from "@mui/material";
import images from "../../../assets/images";
import DynamicInput from "../../../components/form-control/form-builder/form-builder-element/text";
import { useForm } from "react-hook-form";
import Typography from "../../../components/typography/typography";
import Button from "../../../components/button/button";
// import DynamicCheckBox from "../../../components/form-control/form-builder/form-builder-element/checkbox";
import { Eye, EyeOff } from "../../../components/icons";
import { LoginFormValues } from '@erpsquad/common/runtime';
// import { useAuth } from '@erpsquad/common/runtime';
import Toast from "../../../components/toast/toast";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from '@erpsquad/common/runtime';
import { useLocation, useNavigate } from "react-router-dom";
import { getApiConfig } from "@/utils";


const LoginContainer = styled(Grid)(() => ({
      height: "100vh",
    }));
    
    const LeftGrid = styled(Grid)(({ theme }) => ({
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
      backgroundImage: `url(${images.login.LoginLeftBg})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      [theme.breakpoints.down("lg")]: {
        "& img": {
          width: 350,
          height: 350,
        },
      },
      [theme.breakpoints.down("md")]: {
        "& img": {
          width: 300,
          height: 300,
        },
      },
    }));
    
    const RightGrid = styled(Grid)(() => ({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "1rem",
    }));

    const FlexBox = styled(Box)(() => ({
      display: "flex",
      flexDirection: "column",
    }));

    interface FormValeus {
      login: LoginFormValues;
    }

    const validationSchema = Yup.object({
      login: Yup.object({
          password: Yup.string()
          .required("Please enter password")
          .min(8, "Password must be at least 8 characters")
          .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
          .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least one special character"),
          confirm_password: Yup.string().required("Please enter confirm password").oneOf([Yup.ref('password')], "Passwords must match"),
      }),
    });

export const ChangePassword = () => {

    const { control, handleSubmit } = useForm<FormValeus>({
        resolver: yupResolver(validationSchema),
        mode: "all",
    });
     const [toast, setToast] = useState<IToast | null>(null);

    const [showPassword, setShowPassword] = useState<boolean>(false);
    const handleShowPassword = () => setShowPassword(!showPassword);
    const { changePassword } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const onSubmit = async (values: FormValeus) => {
        const token = location.state?.token;
        if (!token) {
            setToast({ message: 'Token missing', type: "alert" });
            return;
        } else {
            values.login.token = token;
            await changePassword(values.login, () => {
                setToast({ message: 'Password changed successfully', type: "normal" });
                setTimeout(() => {
                    navigate(Pathname.LOGIN);
                }, 2000);
            });
        return values;
        }
    };

    const appLogo = getApiConfig().appLogo || images.erp_logo


  return (
    <Box>
          <LoginContainer container>
            <LeftGrid item sm={6}>
              <img src={images.login.LoginLeftSiteImage} />
            </LeftGrid>
            <RightGrid item sm={6} xs={12}>
              <FlexBox
                display="flex"
                flexDirection="column"
                gap={4}
                sx={(theme) => ({
                  minWidth: 400,
                  [theme.breakpoints.down("md")]: {
                    minWidth: 300,
                  },
                  [theme.breakpoints.down("sm")]: {
                    minWidth: 300,
                  },
                })}
              >
                <Box textAlign="center">
                  <img src={appLogo} width={160} height={55}/>
                </Box>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <FlexBox gap={4}>
                    <FlexBox gap={3}>
                      <Box>
                        <Typography
                          align="center"
                          type="h1"
                          weight="medium"
                          color="theme.secondary.1000"
                        >
                          Change Password
                        </Typography>
                        <Typography
                          align="center"
                          type="h5"
                          weight="normal"
                          color="theme.secondary81000"
                        >
                          Enter Details below
                        </Typography>
                      </Box>
                      <FlexBox gap={2}>
                        <Box>
                          <DynamicInput
                            formControl={control}
                            label="Password"
                            name="password"
                            type={"password"}
                            placeholder="Enter Password"
                            fieldArrayName="login"
                          />
                        </Box>
                        <Box>
                          <DynamicInput
                            formControl={control}
                            label="Confirm Password"
                            name="confirm_password"
                            type={showPassword ? "text" : "password"}
                            fieldArrayName="login"
                            endIcon={
                              <>
                                {showPassword ? (
                                  <Eye fontSize="small" htmlColor="#292D32" />
                                ) : (
                                  <EyeOff fontSize="small" htmlColor="#292D32" />
                                )}
                              </>
                            }
                            onIconClick={handleShowPassword}
                            placeholder="Enter confirm password"
                          />
                        </Box>
                      </FlexBox>
                    </FlexBox>
                    <FlexBox gap={2}>
                      <Button type="submit" size="large" variant="contained">
                        Change Password
                      </Button>
                    </FlexBox>
                  </FlexBox>
                </form>
              </FlexBox>
            </RightGrid>
          </LoginContainer>
          <Toast
            open={Boolean(toast)}
            message={toast?.message}
            type={toast?.type}
            handleClose={() => setToast(null)}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            autoHideDuration={3000}
          />
        </Box>
  );
};